import { TaskStatus } from "@myapp/contract";
import { getTaskStatusLabel } from "../../../entities/task";

type Props = {
  title: string;
  status: TaskStatus;
};

export const TaskHeader = ({ title, status }: Props) => {
  const statusClass =
    status === "COMPLETED"
      ? "text-sm font-medium mt-0.5"
      : status === "CANCELLED"
      ? "text-sm font-medium mt-0.5 text-gray-400"
      : status === "DELAYED"
      ? "text-sm font-medium mt-0.5 text-red-500"
      : "text-sm font-medium mt-0.5 text-gray-400";

  const statusStyle =
    status === "COMPLETED" ? { color: "#3BC67D" } : undefined;

  return (
    <div>
      <h1 className="text-xl font-bold text-blue-900">{title}</h1>
      <p className={statusClass} style={statusStyle}>
        {getTaskStatusLabel(status)}
      </p>
    </div>
  );
};
